import AgendaHeaderProperty from './AgendaHeaderProperty';

export default AgendaHeaderProperty;